export const self_order_area_url: string = "self_order_area";